module.exports = __webpack_public_path__ + "img/about-phone-book-img3.85c8e833.png";